import React, {useState} from 'react'

import RegionSelect from 'airship/components/RegionSelect'
import Script from 'airship/components/script'
import getUrl from 'airship/modules/get-url'
import pageContext from 'airship/modules/page-context'
import {switch_is_active} from 'airship/modules/waffle'
import WaffleSwitch from 'airship/modules/waffle/switches'

import AuthAnchorLink from '../components/AuthAnchorLink'
import CenteredLogoBanner from '../components/CenteredLogoBanner'
import CenteredTitledBox from '../components/CenteredTitledBox'
import SingleColumnPage from '../components/SingleColumnPage'
import styles from './styles/LoginPage.module.css'
import TwoPartLoginForm from './TwoPartLoginForm'
import {resolveLoginPageContext} from './types'
import {redirect} from './utils'

const context = pageContext(resolveLoginPageContext)

const LoginPage: React.FC = () => {
  const [recaptchaLoaded, setRecaptchaLoaded] = useState(false)

  return (
    <>
      {context.requireCaptcha && (
        <Script
          async={true}
          onLoad={() => setRecaptchaLoaded(true)}
          url={`https://www.google.com/recaptcha/api.js?render=${context.recaptchaSiteKey}`}
        ></Script>
      )}
      <SingleColumnPage>
        <CenteredLogoBanner />
        <CenteredTitledBox
          title={'Log in to your account'}
          preTitleChild={
            <RegionSelect displayClasses={styles.select} onSelect={redirect} />
          }
        >
          <TwoPartLoginForm recaptchaLoaded={recaptchaLoaded} />
          {context.displayAccountRegistration && (
            <div>
              Don{"'"}t have an account?{' '}
              <AuthAnchorLink
                url={
                  switch_is_active(WaffleSwitch.Onboarding)
                    ? getUrl('registration:onboarding_register')
                    : getUrl('registration:register_ecommerce', 'starter')
                }
                display={'Sign up'}
              />
            </div>
          )}
        </CenteredTitledBox>
      </SingleColumnPage>
    </>
  )
}

export default LoginPage
